import React, { useRef } from 'react';
import ddt from '@wix/da-ddt';
import { ViewerContainerSizeContext } from './ViewerContainerSizeContext';
import { useMeasuredCookie } from '../../Measured/useMeasuredCookie';
const MeasuredViewerContainerSizeContextProvider = ({ children , cookieType , cookieDim , listenOnWindow , innerPadding =0 , className  })=>{
    const containerRef = useRef(null);
    const sentinelRef = useRef(null);
    const containerSize = useMeasuredCookie(cookieType, containerRef, {
        cookieDim,
        sentinelRef,
        listenOnWindow
    });
    const width = containerSize ? containerSize.width - innerPadding : undefined;
    ddt.log('measuredhook', 'MeasuredViewerContainerSizeContextProvider', {
        width,
        containerSize,
        innerPadding
    });
    return /*#__PURE__*/ React.createElement(ViewerContainerSizeContext.Provider, {
        value: width
    }, /*#__PURE__*/ React.createElement("div", {
        ref: sentinelRef,
        style: {
            maxWidth: '100%'
        }
    }), /*#__PURE__*/ React.createElement("div", {
        className: className,
        ref: containerRef
    }, children));
};
MeasuredViewerContainerSizeContextProvider.displayName = 'MeasuredViewerContainerSizeContextProvider';
export default MeasuredViewerContainerSizeContextProvider;
